import React from 'react';

import { NavLink } from 'react-router-dom';

class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.showAutoRefund = this.showAutoRefund.bind(this)
  }

  showAutoRefund() {
    this.props.showAutoRefund()
  }

  render() {
    return (
      <div className="footer">
        <div className="footer__top">
          <div className="wd">
            <div className="footer__section">
              <p className="footer__section__heading">Кінотеатр</p>
              <p><a href="/">Сеанси</a></p>
              <p><a href="/">Акції та новини</a></p>
              <p><a href="/">Original Language</a></p>
            </div>
            <div className="footer__section">
              <p className="footer__section__heading">Про нас</p>
              <p><a href="/history">Icторiя</a></p>
              <p><a href="/">Книгарня-відеотека</a></p>
              <p><a href="/">Кінокафе</a></p>
              {/* <p><NavLink to="/cafe">Кінокафе</NavLink></p> */}
              <p><a href="/">Зали</a></p>
            </div>
            <div className="footer__section">
              <p className="footer__section__heading">Нашi Контакти</p>
              <p><a href="/">Замовникам</a></p>
              <p><NavLink to="/contacts">Контакти</NavLink></p>
              <p><span href="#" onClick={this.showAutoRefund}>Повернення квитків</span></p>
              <p><a href={ process.env.REACT_APP_PDF_PATH_TO_ATTENDANCE_RULES } target="_blank">Правила відвідування</a></p>
            </div>
            <div className="footer__section soc">
              <p className="footer__section__heading">Ми в мережi</p>
              <p>
                <a target="_blank" href="http://instagram.com/zhovten.cinema" className="ig"><img src="/img/footer_ig.svg" alt="" /></a>
                <a target="_blank" href="https://www.facebook.com/zhovten/"><img src="/img/footer_fb.svg" alt="" /></a>
              </p>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <div className="wd">
            <div className="footer__copyright">
              <p>©2005 - { new Date().getFullYear() }, Кінотеатр «Жовтень»</p>
              <p>Будь-яке використання інформації з сайту можливе лише з письмової згоди адміністрації кінотеатра</p>
            </div>
            <a href="http://foxima.org"><div className="footer__foxima__logo">
              <span>made by</span><img src="/img/foxima_logo.svg" alt="" />
            </div></a>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/snippets/Footer.jsx